import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { SlackCounter, SlackSelector } from 'react-reactions';
import { fetchReactions, createReactions } from '../../actions';

class Reactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counters: [{
      }],
      showSelector: false,
    };
  }

  componentDidMount() {
    this.props.fetchReactions(this.props.match.params.pageID);
    const counters = this.props.currReactions.map((reaction) => {
      return ({ emoji: reaction.type, by: reaction.Author.username });
    });
      // eslint-disable-next-line react/no-did-update-set-state
    this.setState(
      {
        counters,
      },
    );
  }

  componentDidUpdate(prevProps) {
    if ((this.props.currReactions.length !== prevProps.currReactions.length)) {
      this.props.fetchReactions(this.props.match.params.pageID);
      const counters = this.props.currReactions.map((reaction) => {
        return ({ emoji: reaction.type, by: reaction.Author.username });
      });
      this.setState(
        {
          counters,
        },
      );
    }
  }

  handleAdd = () => this.setState({ showSelector: true })

  handleSelect = (emoji) => {
    this.props.createReactions(this.props.match.params.pageID, emoji);
    this.setState({ showSelector: false });
  }

  render() {
    return (
      <div className="react" style={{ position: 'relative' }}>
        <p className="head"> add a reaction!</p>
        <SlackCounter
          counters={this.state.counters}
          user={this.props.author.username}
          onAdd={this.handleAdd}
          onSelect={this.handleSelect}
        />

        { this.state.showSelector ? (
          <div style={{
            position: 'absolute', bottom: '100%', marginBottom: '10px', height: '40%', zIndex: '10',
          }}
          >
            <SlackSelector onSelect={this.handleSelect} />
          </div>
        ) : null }
      </div>
    );
  }
}
const mapStateToProps = (state) => (
  {
    currReactions: state.reactions.all,
    author: state.author.current,
    currPage: state.pages.current,
  }
);

export default withRouter(connect(mapStateToProps, { fetchReactions, createReactions })((Reactions)));
